<template>
  <div class="box">
    <navBar :tabIndex="99" :showLogo="true"></navBar>
    <div class="venue-topbg"></div>
    <div class="tabBox">
      <div class="tabIt">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          class="tabItem"
          @click="tabChange(index)"
          :style="{
            color: tabIndex == index ? '#45796E' : '#8A8A8A',
          }"
        >
          {{ item.name }}
          <div class="t-line" v-if="tabIndex == index"></div>
        </div>
      </div>
    </div>
    <div class="form-content">
      <img
        v-if="genealogyData.length && tabIndex == 0"
        @click="batchAdd"
        src="@/assets/datch-add.png"
        style="position: absolute; top: 0; cursor: pointer"
        :style="{
          width: $px2rem(`${170}px`),
          height: $px2rem(`${49}px`),
          right: $px2rem(`${100}px`),
        }"
      />
      <el-form
        class="form-content-form"
        ref="form"
        :model="form"
        :label-width="$px2rem(`${100}px`)"
        label-position="left"
      >
        <el-form-item label="逝者照片：">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            :action="action"
            :headers="header"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            accept=".png,.jpg,.jpeg"
            @mouseenter.native="mouseCover"
            @mouseleave.native="mouseOut"
          >
            <img v-if="form.picture" :src="form.picture" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <span class="placeholderText" v-if="!form.picture"
              >请上传逝者照片</span
            >
            <div class="mouse-info" v-show="showInfo">
              <img src="@/assets/upload-icon.png" />
              <div class="text">修改照片</div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="逝者姓名：" required>
          <el-input
            v-model="form.name"
            maxlength="5"
            :style="{
              width: $px2rem(`${371}px`),
            }"
          ></el-input>
        </el-form-item>
        <el-form-item label="逝者性别：" required>
          <el-select
            v-model="form.sex"
            placeholder="请选择性别"
            :style="{
              width: $px2rem(`${371}px`),
            }"
          >
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tabIndex == 1" label="名人类目：" required>
          <el-select
            v-model="form.typeId"
            placeholder="请选择类目"
            :style="{
              width: $px2rem(`${371}px`),
            }"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in hallTypeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期：">
          <div class="mossFlex">
            <el-date-picker
              v-model="form.birthDay"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="暂无选择"
              @change="changeDate(1)"
              :style="{
                width: $px2rem(`${371}px`),
              }"
            >
            </el-date-picker>
            <div
              :class="!form.noBirth ? 'noMoreed' : 'noMoress'"
              @click="clearDate(1)"
            >
              不详
              <img
                class="checkIcon"
                src="@/assets/check-icon.png"
                alt=""
                v-if="form.noBirth"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="逝世日期：">
          <div class="mossFlex">
            <el-date-picker
              v-model="form.dieDay"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="暂无选择"
              @change="changeDate(0)"
              :style="{
                width: $px2rem(`${371}px`),
              }"
            >
            </el-date-picker>
            <div
              :class="!form.noDie ? 'noMoreed' : 'noMoress'"
              @click="clearDate(0)"
            >
              不详
              <img
                class="checkIcon"
                src="@/assets/check-icon.png"
                alt=""
                v-if="form.noDie"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="安葬地址：">
          <el-cascader
            v-model="form.burialAddress"
            separator=" "
            :options="options"
            :props="{
              label: 'label',
              value: 'value',
              checkStrictly: true,
              emitPath: false,
              expandTrigger: 'hover',
              children: 'children',
            }"
            :style="{
              width: $px2rem(`${371}px`),
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="是否公开：" v-if="tabIndex == 0">
          <div>
            <el-switch
              v-model="form.publicStatus"
              active-text="公开"
              active-color="#45796E"
              :active-value="1"
              :inactive-value="2"
            ></el-switch>
          </div>
        </el-form-item>
        <el-form-item v-if="tabIndex == 2" label="简介：">
          <el-input
            type="textarea"
            placeholder="简介,限制150字符"
            v-model="form.introduction"
            :style="{
              width: $px2rem(`${371}px`),
            }"
          ></el-input>
        </el-form-item>
        <el-form-item label="生平介绍：">
          <div>
          <el-input
            type="textarea"
            placeholder="叙写逝者生平简介"
            v-model="form.remark"
            :style="{
              width: $px2rem(`${371}px`),
            }"
          ></el-input>
          <div class="tips"><span style="color:#D5422C">*</span>尊重生命，尊重逝者，请填写真实信息</div>

          </div>
        </el-form-item>
        

        <el-form-item>
          <div
            :class="{ saveBut: true, 'active-btn': isComputed }"
            @click="saveForm"
          >
            保存
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :visible.sync="DialogVisible"
      :width="$px2rem(`${972}px`)"
      :before-close="closeBuildquick"
      center
    >
      <div slot="title">
        <div class="dialog-title">批量建馆</div>
        <div class="dialog-label">族谱内逝世的亲人支持同步批量建馆</div>
        <div class="searchMan-inp">
          <img
            class="searchicon"
            src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/searchIcon-gray.png"
            alt=""
          />
          <input
            v-model="memberName"
            type="text"
            class="searchinp"
            @keyup.enter="searchMan"
            @change="clearSearch"
            placeholder="搜索族员"
          />
          <div class="search-btn" @click="searchMan">搜索</div>
        </div>
      </div>
      <div class="genealogyIt">
        <div
          class="genealogy-item"
          v-for="(item, index) in genealogyData"
          :key="index"
        >
          <div class="geoItem">
            <img
              class="geoImg"
              :src="
                item.createType == 1
                  ? 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/jpImg-1-s.png'
                  : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/zpImg-1-s.png'
              "
              v-if="item.color == '#47568F'"
              alt=""
            />
            <img
              class="geoImg"
              :src="
                item.createType == 1
                  ? 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/jpImg-2-s.png'
                  : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/zpImg-2-s.png'
              "
              v-if="item.color == '#4CA173'"
              alt=""
            />
            <img
              class="geoImg"
              :src="
                item.createType == 1
                  ? 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/jpImg-3-s.png'
                  : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/zpImg-3-s.png'
              "
              v-if="item.color == '#685882'"
              alt=""
            />
            <img
              class="geoImg"
              :src="
                item.createType == 1
                  ? 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/jpImg-4-s.png'
                  : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/zpImg-4-s.png'
              "
              v-if="item.color == '#FFB634'"
              alt=""
            />
            <img
              class="geoImg"
              :src="
                item.createType == 1
                  ? 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/jpImg-5-s.png'
                  : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/zpImg-5-s.png'
              "
              v-if="item.color == '#B95A5A'"
              alt=""
            />
            <img
              class="geoImg"
              :src="
                item.createType == 1
                  ? 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/jpImg-6-s.png'
                  : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/144/zpImg-6-s.png'
              "
              v-if="item.color == '#9C7342'"
              alt=""
            />
            <div class="geoName">{{ item.genealogyName }}</div>
            <div class="geoNum">{{ item.memberCount }}人</div>
            <div
              class="geoSort"
              @click.stop="getSonSortItem(item, index)"
              v-if="item.memberCount > 1"
              :style="{
                color: item.sort == 'asc' ? '#575757' : '#45796E',
              }"
            >
              {{ item.sort == "asc" ? "世代排序" : "世代倒序" }}
              <img
                class="sortIcon"
                src="@/assets/filterIcon.png"
                alt=""
                v-if="item.sort == 'asc'"
              />
              <img
                class="sortIcon"
                src="@/assets/filterIcon-green.png"
                alt=""
                v-else
              />
            </div>
            <i
              class="openSon"
              @click.stop="getSonItem(item, index)"
              :class="{
                'el-icon-arrow-down': !item.check,
                'el-icon-arrow-up': item.check,
              }"
            ></i>
          </div>
          <div
            v-if="item.check"
            class="geoSon"
            style="overflow: auto"
            @scroll="loadScroll($event, item, index)"
          >
            <div
              class="geoSonItem"
              v-for="(item1, index1) in item.members"
              :key="index1"
              :style="{
                'margin-right': index1 % 2 != 0 ? '0' : $px2rem(`${14}px`),
              }"
            >
              <img
                class="geosImg"
                :src="item1.picture"
                alt=""
                v-if="item1.picture"
              />
              <div class="tombstone-bg" v-else>
                <img class="tomImg" src="@/assets/tombstone-bg.png" alt="" />
                <div class="tomName">
                  <div
                    v-for="(item, index) in item1.name.slice(0, 5)"
                    :key="index"
                    :style="{
                      'font-size':
                        item1.name?.length >= 5
                          ? $px2rem(`${7}px`)
                          : item1.name?.length >= 4
                          ? $px2rem(`${8}px`)
                          : $px2rem(`${9}px`),
                      'line-height': 1,
                    }"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
              <div class="geoInfo">
                <div class="geoInfoCen">
                  <span class="geoName">{{
                    item1.name?.length > 5
                      ? item1.name.slice(0, 5) + "..."
                      : item1.name
                  }}</span>
                  <span class="geoCentry">(第{{ item1.generation }}世)</span>
                </div>
                <div>
                  <span class="geoTime">逝世日期:</span>
                  <span class="geodieTime">{{
                    item1.dieDay ? item1.dieDay + "(阳历)" : "未知"
                  }}</span>
                </div>
              </div>
              <img
                class="geoCheck"
                :src="
                  item1.check
                    ? 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/checkedMan.png'
                    : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo2/checkMan.png'
                "
                alt=""
                @click.stop="checkMans(item1, index1)"
              />
            </div>
            <!-- <vue-scroll ref="scroll" :ops="ops" @handle-scroll="handleScroll">
            <div
              class="geoSonItem"
              v-for="(item, index) in item.members"
              :key="index"
            >
              {{ item.name }}
            </div>
          </vue-scroll> -->
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="ensure-btn" @click="fastCreate">
          快速创建<span v-if="checkManNum > 0">({{ checkManNum }})</span>
        </div>
      </span>
    </el-dialog>
    <tabBar></tabBar>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { getToken } from "@/utils/auth";
import area from "@/pages/memo/area.json";
import {
  addMemberHall,
  addSyncHall,
  getDieMember,
  getGenealogyList,
  getGenealogyListMembers,
  getHallTypePage,
  applyMemberHalls,
} from "@/api/request";
import { toChinesNum, debounce } from "@/utils/index";
// import {debounce} from "@/utils/dbucTrtl";

export default {
  data() {
    return {
      action:
        process.env.BASE_URL.replace("subapp/sub-pc", "mmwz-app") +
        "api/video/uploadUrl",
      header: {
        Authorization: "Bearer " + getToken(),
      },
      showInfo: false,
      form: {
        birthDay: "",
        burialAddress: null,
        dieDay: "",
        name: "",
        picture: "",
        publicStatus: 2, //1:打开 2：关闭
        remark: "",
        sex: null, //1:男 2：女
        type: null,
        introduction: "",
        typeId: null, //名人类目
      },
      options: area,
      DialogVisible: false,
      genealogyData: [],
      toChinesNum: toChinesNum,
      checkedId: [],
      params: {
        all: false,
        memberIds: "",
      },
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingX: false, //关闭横向滚动
        },
        rail: {
          keepShow: true,
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: "#efefef", //滚动条颜色
          opacity: 0.8, //滚动条透明度
        },
      },
      memberData: [],
      memberName: "",
      tabList: [
        {
          type: 2,
          name: "家族纪念馆建馆",
        },
        {
          type: 1,
          name: "名人建馆",
        },
        {
          type: 3,
          name: "始祖建馆",
        },
      ],
      tabIndex: 0,
      hallTypeList: [],
    };
  },
  computed: {
    dayjs() {
      return dayjs;
    },

    isComputed() {
      if (
        this.form.name &&
        this.form.sex &&
        this.form.typeId &&
        this.tabIndex == 1
      ) {
        return true;
      } else if (this.form.name && this.form.sex && this.tabIndex !== 1) {
        return true;
      } else {
        return false;
      }
    },
    checkManNum() {
      let num = 0;
      this.memberData = [];
      console.log(this.genealogyData);
      this.genealogyData.map((e) => {
        e.members.map((e1, i1) => {
          if (num >= 0 && e1.check) {
            console.log(e1, num);
            num++;
            this.memberData.push(e1);
            if (num > 0 && e1.check == false) {
              num--;
              this.memberData.splice(i1, 1);
            }
          }
        });
      });
      return num;
    },
  },
  created() {
    this.getDieMembers();
    this.hallType();
    if (this.$route.query.type) {
      this.tabIndex = Number(this.$route.query.type);
    }
  },
  methods: {
    hallType() {
      getHallTypePage({ pageNum: 1, pageSize: 10000 }).then((r) => {
        this.hallTypeList = r.data.result.records;
      });
    },
    tabChange(i) {
      this.tabIndex = i;
      this.form = {
        birthDay: "",
        burialAddress: null,
        dieDay: "",
        name: "",
        picture: "",
        publicStatus: 2, //1:打开 2：关闭
        remark: "",
        sex: null, //1:男 2：女
        type: null,
        introduction: "",
        typeId: null, //名人类目
      };
    },
    clearSearch() {
      if (this.memberName == "") {
        this.getDieMembers();
      }
    },
    searchMan() {
      console.log(this.memberName);
      this.getDieMembers(this.memberName);
    },
    closeBuildquick() {
      this.DialogVisible = false;
      this.memberData = [];
      this.memberName = "";
      this.genealogyData.map((e) => {
        e.check = false;
        e.total = 0;
        e.pageNo = 1;
        e.members = [];
        e.members.map((e1, i1) => {
          e1.check = false;
        });
      });
    },
    checkMans(e, i) {
      console.log(e, i);
      e.check = !e.check;
    },
    loadScroll(event, item, index) {
      console.log(
        this.genealogyData[index].total,
        this.genealogyData[index].pageNo
      );
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时触发加载更多
      if (
        scrollTop + clientHeight >= scrollHeight - 5 &&
        this.genealogyData[index].total > this.genealogyData[index].pageNo * 50
      ) {
        // 留出5px的边距
        this.genealogyData[index].pageNo++;
        this.pushMember(this.genealogyData[index], index);
      }
    },
    handleScroll(e, position) {
      console.log(position);
    },
    getSonSortItem(e, i) {
      e.check = true;
      if (e.sort == "asc") {
        e.sort = "desc";
      } else if (e.sort == "desc") {
        e.sort = "asc";
      }
      if (e.check == true) {
        this.genealogyData[i].members = [];
        this.genealogyData[i].pageNo = 1;
        this.pushMember(e, i);
      } else {
        this.genealogyData[i].members = [];
        this.genealogyData[i].pageNo = 1;
      }
      this.$forceUpdate();
    },
    getSonItem(e, i) {
      console.log(e);
      e.check = !e.check;
      if (e.check == true) {
        this.pushMember(e, i);
      } else {
        this.genealogyData[i].members = [];
        this.genealogyData[i].pageNo = 1;
      }
      this.$forceUpdate();
    },
    pushMember(e, i) {
      let data = {
        genealogyId: e.genealogyId,
        pageNo: e.pageNo,
        pageSize: e.pageSize,
        memberName: this.memberName,
        sort: e.sort,
      };
      getGenealogyListMembers(data).then((res) => {
        this.genealogyData[i].total = res.data.result.total;
        res.data.result.records.map((e) => {
          e.check = false;
        });
        this.genealogyData[i].members = [
          ...this.genealogyData[i].members,
          ...res.data.result.records,
        ];
        console.log(this.genealogyData);
      });
    },
    mouseCover() {
      if (this.form.picture) {
        setTimeout(() => {
          this.showInfo = true;
        }, 300);
      }
    },
    mouseOut() {
      if (this.form.picture) {
        setTimeout(() => {
          this.showInfo = false;
        }, 300);
      }
    },
    getDieMembers(memberName) {
      if (memberName) {
        getGenealogyList({
          memberName: memberName,
        }).then((res) => {
          this.genealogyData = res.data.result;
          this.genealogyData.map((e) => {
            e.check = false;
            e.sort = "asc";
            e.pageNo = 1;
            e.pageSize = 50;
            e.total = 0;
          });
        });
      } else {
        getGenealogyList().then((res) => {
          this.genealogyData = res.data.result;
          this.genealogyData.map((e) => {
            e.check = false;
            e.sort = "asc";
            e.pageNo = 1;
            e.pageSize = 50;
            e.total = 0;
          });
        });
      }
    },
    selectCheck(item) {
      item.checked = !item.checked;
      let arr = this.genealogyData.flatMap((item) => item.members);
      let checkedId = arr.filter((item) => item.checked);
      this.checkedId = checkedId.map((item) => {
        return item.id;
      });
    },
    batchAdd() {
      this.DialogVisible = true;
      // this.genealogyData.map((item) => {
      //   if (item.members.length) {
      //     item.members.map((child) => {
      //       child.checked = false;
      //       return child;
      //     });
      //   }
      //   return item;
      // });
      this.params.memberIds = "";
    },
    fastCreate: debounce(function () {
      console.log(this.memberData);
      // this.params.memberIds = this.checkedId.join(",");
      this.addSyncHalls();
    }, 300),
    addSyncHalls() {
      if (this.memberData?.length == 0) {
        this.$message.warning({
          message: "请选择族谱内逝世的亲人",
          offset: 80,
        });
        return;
      }
      let arr = this.memberData.map((e) => {
        return e.id;
      });
      let data = {
        memberIds: arr.join(","),
      };
      addSyncHall(data).then((res) => {
        if (res.data.code === 200) {
          this.$message.success({
            message: "创建成功",
            offset: 80,
          });
        } else {
          this.$message.error({
            message: res.msg,
            offset: 80,
          });
        }
        this.getDieMembers();
        this.closeBuildquick();
      });
    },
    handleAvatarSuccess(res, file) {
      this.form.picture = res.fileName;
    },
    changeDate(e) {
      if (e == 0) {
        if (this.form.deadDay !== "") {
          this.form.noDie = false;
        }
      } else {
        if (this.form.birthDay !== "") {
          this.form.noBirth = false;
        }
      }
    },
    clearDate(e) {
      if (e == 0) {
        this.form.noDie = !this.form.noDie;
        if (this.form.noDie == true) {
          this.form.dieDay = null;
        }
      } else {
        this.form.noBirth = !this.form.noBirth;
        if (this.form.noBirth == true) {
          this.form.birthDay = null;
        }
      }
    },
    saveForm: debounce(function () {
      if (!this.form.name || !this.form.sex) {
        return;
      }
      if (!this.form.typeId && this.tabIndex == 1) {
        return;
      }
      this.form.type = this.tabList[this.tabIndex].type;
      if (this.tabIndex == 1 || this.tabIndex == 2) {
        this.form.publicStatus = 1;
      }
      if (this.tabIndex == 0) {
        addMemberHall(this.form).then((res) => {
          if (res.data.code === 200) {
            this.$message.success("创建成功");
            this.form = {
              birthDay: "",
              burialAddress: null,
              dieDay: "",
              name: "",
              picture: "",
              publicStatus: 2, //1:打开 2：关闭
              remark: "",
              sex: null, //1:男 2：女
              type: null,
              introduction: "",
              typeId: null, //名人类目
            };
            this.$router.push({ path: "homeMemo", query: { id: 2 } });
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        applyMemberHalls(this.form).then((res) => {
          if (res.data.code === 200) {
            this.$message.success(
              "提交成功，审核结果1-3个工作日将以短信方式告知您，感谢配合！"
            );
            this.form = {
              birthDay: "",
              burialAddress: null,
              dieDay: "",
              name: "",
              picture: "",
              publicStatus: 2, //1:打开 2：关闭
              remark: "",
              sex: null, //1:男 2：女
              type: null,
              introduction: "",
              typeId: null, //名人类目
            };
            if (this.tabIndex == 1) {
              this.$router.push({ path: "memo", query: { id: 1 } });
            } else {
              this.$router.push({ path: "founder" });
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    }, 300),
  },
};
</script>
<style lang="scss" scoped>
.tabBox {
  background: #fff;
  width: 100%;
  height: 75px;
  .tabIt {
    width: 1200px;
    height: 75px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .tabItem {
      margin-right: 40px;
      color: #8a8a8a;
      font-size: 18px;
      cursor: pointer;
      position: relative;
      display: flex;
    }
    .t-line {
      border-radius: 5px;
      height: 3px;
      background: #45796e;
      position: absolute;
      bottom: -26px;
      left: 0;
      right: 0;
      margin: 0 auto;
      flex: 1;
      width: 70%;
    }
  }
}
.box {
  background: #f4f5f7;
}
:deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: #edeef0;
}
.avatar-uploader .el-upload:hover {
  border-color: #45796e;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border-radius: 5px;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
  border-radius: 10px;
  object-fit: cover;
}
:deep .el-dialog__body {
  /* 隐藏滚动条的样式 */
  ::-webkit-scrollbar {
    background: transparent;
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
  }
}
</style>
<style lang="scss" scoped>
@import "./venue.scss";
:deep .el-input__inner {
  border-color: #ffffff;
}
:deep .el-textarea__inner {
  border-color: #ffffff;
}
:deep .el-form-item__content {
  display: flex;
  align-items: center;
}
:deep .el-switch__label.is-active {
  color: #45796e;
}
:deep .el-input__inner:focus {
  border-color: #45796e;
}
:deep .el-dialog {
  border-radius: 10px;
}
:deep .el-dialog__header {
  background-image: url("../../assets/dialog-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 157px;
  box-sizing: border-box;
  background-repeat: round;
  background-position: center;
}
:deep .el-dialog__body {
  background: #f4f5f7;
  height: 410px;
  overflow-y: scroll;
  padding-top: 4px;
}
:deep .el-dialog__footer {
  background: #f4f5f7;
  border-radius: 0 0 10px 10px;
}
.avatar-uploader {
  position: relative;
}
.placeholderText {
  color: #575757;
  font-size: 14px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;
}
.mouse-info {
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  height: 0.78125rem;
  flex-direction: column;
  align-items: center;
  width: 150px;
  padding-top: 25%;
  .text {
    font-size: 14px;
    color: #ffffff;
  }
}
.venue-topbg {
  width: 100%;
  height: 100px;
  background: url("../../assets/venue1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.form-content {
  width: 1200px;
  margin: 61px auto;
  position: relative;
  &-form {
    width: 500px;
    .formIt {
      display: flex;
    }
    .mossFlex {
      display: flex;
    }
    .noMoress {
      width: 100px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 500;
      color: #45796e;
      border-radius: 10px;
      border: 1px solid #45796e;
      margin-left: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .noMoreed {
      width: 100px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 500;
      color: #575757;
      border-radius: 10px;
      background: #ffffff;
      margin-left: 20px;
      cursor: pointer;
    }
    .checkIcon {
      width: 17.76px;
      height: 12.15px;
    }
    .saveBut {
      width: 322px;
      line-height: 50px;
      color: #fff;
      background: #c8c8c8;
      border-radius: 40px;
      text-align: center;
    }
    .active-btn {
      background: #45796e;
    }
  }
}
.dialog-title {
  font-size: 20px;
  color: #323232;
  font-weight: 600;
  margin-bottom: 12px;
}
.dialog-label {
  font-size: 14px;
  color: #575757;
}
.genealogyIt {
  //min-height: 600px;
}
.genealogy-item {
  &-name {
    font-size: 16px;
    font-weight: 600;
    color: #323232;
  }
  .child-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 8px 0 16px 0;
  }
  &-child {
    display: flex;
    align-items: center;
    width: 400px;
    min-height: 135px;
    background: #ffffff;
    padding: 10px 20px;
    margin-bottom: 14px;
    border-radius: 10px;
    cursor: pointer;
    &-picture {
      width: 76px;
      height: 76px;
      border-radius: 10px;
    }
    &-default {
      position: relative;
    }
    &-name {
      width: 15px;
      height: 75px;
      color: #ffffff;
      font-size: 10px;
      position: absolute;
      top: 18px;
      left: 43%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-info {
      flex: 1;
      margin-left: 20px;
      .name {
        font-size: 20px;
        font-weight: 600;
        color: #323232;
        margin-bottom: 7px;
        span {
          margin-left: 11px;
          font-size: 18px;
          color: #45796e;
        }
      }
      .date {
        font-size: 14px;
        color: #8a8a8a;
        span {
          color: #323232;
        }
      }
    }
    &-radio {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #e9e9e9;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  .cancel-btn {
    width: 144px;
    background: #ffffff;
    line-height: 48px;
    font-size: 17px;
    color: #45796e;
    border-radius: 8px;
    margin-right: 18px;
    cursor: pointer;
  }
  .ensure-btn {
    width: 144px;
    background: #45796e;
    line-height: 48px;
    font-size: 17px;
    color: #ffffff;
    border-radius: 8px;
    cursor: pointer;
  }
}
.tips{
  font-size:14px;
  color:#666565;
  text-align:left;
}
</style>
